// extracted by mini-css-extract-plugin
module.exports = {"root":"ClientCreditCards_root__18jL-","cards":"ClientCreditCards_cards__IB2lZ","empty":"ClientCreditCards_empty__tip5_"};